<template>
  <div class="header-com">
    <div class="wrap" :style="{color:stylehead.color,background:stylehead.background}">
      <div class="left-area">
        <img class="img logo" src="../assets/logo.png" width="220px;height:56px;" />
        <img class="img logo2" src="../assets/logo2.png" width="220px;height:56px;" />
      </div>
      <div class="right-area">
        <div class="list" :class="{show: show}">
          <!-- <router-link v-for="(item,index) in currentData" :key='index' tag="li" class="item" :style="{color:stylehead.color}" :to="item.path">
            <div class="span" @click="handleClick(item)">{{item.name}}</div>
          </router-link> -->
          <div class="item" 
            v-for="(item,index) in currentData"
            :key='index'
            :class="{acitve: acitve === item.name}"
            @click="handleClick(item)"
          >{{item.name}}</div>
        </div>
        <div class="nav">
          <img v-if="show" src="../assets/nav2.png" alt="" @click="handleShowNav">
          <img v-else src="../assets/nav.png" alt="" @click="handleShowNav">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['stylehead', 'offsetTop'],
  data() {
    return {
      currentData:[
        {name:'ABOUT',path:'/about'},
        // {name:'PROD UCT',path:'/product'},
        /*{name:'GAMES',path:'/games'},*/
        {name:'FEATURES',path:'/features'},
      ],
      selectFlag:false,
      show: false,
      acitve: 'ABOUT',
    };
  },
  mounted(){
    window.addEventListener('scroll', this.onScroll, true);
  },
  methods: {
    onScroll() {
      let about = document.getElementById('about');
      let games = document.getElementById('games');
      let features = document.getElementById('features');
      let scrollHeight = document.documentElement.scrollTop;
      let top = window.innerWidth > 750 ? 80 : 50;

      if(scrollHeight >= (features.offsetTop - top)) {
        this.acitve = 'FEATURES'
      }/*else if(scrollHeight >= (games.offsetTop - top)) {
        this.acitve = 'GAMES'
      }*/else if(scrollHeight >= (about.offsetTop - top)) {
        this.acitve = 'ABOUT';
      }else {
        this.acitve = ''
      }
    },
    showSelect() {
      this.selectFlag = true;
    },
    handleShowNav() {
      this.show = !this.show
    },
    gotop(){
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      })
    },
    handleClick(item) {
      let about = document.getElementById('about');
      let games = document.getElementById('games');
      let features = document.getElementById('features');
      let top = window.innerWidth > 750 ? 80 : 50;
      if(item.name === 'ABOUT') {
        window.scrollTo({
          left: 0,
          top: about.offsetTop - top,
          behavior: 'smooth'
        })
      }else if(item.name === 'GAMES') {
        window.scrollTo({
          left: 0,
          top: games.offsetTop - top,
          behavior: 'smooth'
        })
      }else if(item.name === 'FEATURES') {
        window.scrollTo({
          left: 0,
          top: features.offsetTop - top,
          behavior: 'smooth'
        })
      }
      this.show = false;
      // this.acitve = item.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.header-com {
  position: relative;
  // width: 100%;
  // top: 0;
  // z-index: 999;
  @media screen and (min-width: 350px) and (max-width: 750px) {
    & {
      height: 50px;
    }
    .wrap {
      height: 50px;
      .left-area {
        width: 50px;
        line-height: 50px;
        text-align: center;

        .logo2 {
          display: inline;
          width: 30px;
        }
      }
      .right-area {
        position: relative;
        .nav {
          float: right;
          height: 100%;
          display: flex;
          align-items: center;
          margin-right: 20px;
          img {
            width: 30px;
            height: 30px;
          }
        }
        .list {
          position: absolute;
          right: 0px;
          top: 50px;
          width: max-content;
          margin: 0;
          padding: 20px;
          background: #302F2D;
          z-index: 99;
          transition: all .5s;

          &.show {
            display: inline-block;
          }

          .item {
            line-height: 30px;
            text-align: right;
            color: #ccc;
            &.acitve {
              color: #fff;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: 751px) {
    & {
      height: 80px;
    }
    .wrap {
      height: 80px;
      .left-area {
        width: 30%;
        line-height: 80px;
        padding-right:80px;
        text-align: right;
        .logo {
          display: inline;
        }
      }
      .right-area {
        .list {
          padding-right: 76px;
          float: right;
          display: inline-block;
          line-height: 80px;
          .item {
            color: #fff;
            text-align: left;
            display: inline-block;
            margin-right: 49px;
            position: relative;

            &.acitve {
              font-weight: bold;
              &::after {
                width: 50%;
                height: 2px;
                background:#FFFFFF;
                position:absolute;
                display: block;
                content:" ";
                bottom:25px;
                left: 50%;
                transform: translateX(-50%);
              }
            }
            
            .span {
              width: 100%;
              height: 100%;
            }
            
          }
            // &::after {

            //   width: 50%;
            //   height: 2px;
            //   background:#FFFFFF;
            //   position:absolute;
            //   display: block;
            //   content:" ";
            //   bottom:25px;
            //   left: 50%;
            //   transform: translateX(-50%);
            // }
        }
      }
    }
  }
  
  .wrap {
    width: 100%;
    display: flex;
    align-items: center;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 99;
    .left-area {
      height: 100%;
      background-color: #D82237;

      img{
        width: 100px;
        display: none;
        vertical-align: middle;
      }
    }
    
    .right-area {
      height: 100%;
      flex: 1;
      background-color: #211B1B;
      // display: flex;
      // justify-content: right;
      .list {
        .item {
          font-size: 16px;
          cursor: pointer;
        }
        .selct-area {
          box-sizing: border-box;
          position: relative;
          display: inline-block;
          width: 104px;
          height: 32px;
          line-height: 32px;
          color: #fff;
          border-radius: 3px 3px;
          background: rgba(255, 255, 255, 0.3);
          font-size: 14px;
          text-align: left;
          padding-left: 6px;
          cursor: pointer;
          .text {
            display: inline-block;
            width: 100%;
            height: 100%;
            position: relative;
            padding-left: 6px;
            .icon {
              position: absolute;
              top: 12px;
              right: 16px;
              width: 0;
              height: 0;
              border-width: 6px;
              border-style: solid;
              border-color: #fff transparent transparent transparent;
            }
          }
          .select-list {
            box-sizing: border-box;
            width: 104px;
            position: absolute;
            left: 0;
            top: 32px;
            background: rgba(255, 255, 255, 0.3);
            padding-left: 6px;
            .select-item {
              box-sizing: border-box;
              font-size: 14px;
              padding-left: 6px;
            }
          }
        }
      }
      > div,
      > ul {
        display: none;
      }
    }
  }
}
</style>